<template>
    <DashboardTable
            :archiveUpdate="archiveUpdateComputed"
            @handleArchive="handleArchive"
            @editAppClicked="emitStateChanged($event, 'appEdit')"
            @adUnitClicked="emitStateChanged($event, 'adSettings.container.placements')"
    />
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import DashboardTable from '../pages/dashboard/DashboardTable.vue';
import eventBus from '../mixins/eventBus';
import externalParsedProps from '../mixins/externalParsedProps';

const parsedProps = ['archiveUpdate'];

export default {
    name: 'DashboardTableEx',
    mixins: [
        eventBus('dashboard-table-ex'),
        externalParsedProps(DashboardTable.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(DashboardTable.props, parsedProps),
    components: { DashboardTable },
    methods: {
        handleArchive(data) {
            this.$emit('handleArchive', data);
        },
        emitStateChanged(event, action) {
            this.$emit('stageChange', { params: event, state: action });
        }
    }
};
</script>
